
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";


const defaultDropList: string[] = [wBComponentTypeNames.tabContainer, wBComponentTypeNames.pageRoot,wBComponentTypeNames.accordion, wBComponentTypeNames.section, wBComponentTypeNames.footer, wBComponentTypeNames.column, wBComponentTypeNames.row,wBComponentTypeNames.container];


export const editTextPlaceHolder = "Your Text Here";
export const blogPlaceHolderText = 'Write your blog post'

export const defaultAttributeSizingOnly = [
    "width",
    "height",
    "maxHeight",
    "maxWidth",
    "minHeight",
    "minWidth",
    componentAttributeTypes.animation,

  
];

export const anchorDefinitions =[
    "anchor",
    "anchorType",
    "left",
    "right",
    "top",
    "bottom",

]

export const backgroundImageList = [


    attributeTypes.backgroundImage,
    attributeTypes.backgroundSize,
    attributeTypes.backgroundPosition,
    attributeTypes.backgroundRepeat,
    attributeTypes.backgroundAttachment,
]


const defaultAttributeList: string[] = 
[
    // "letterSpacing",
    componentAttributeTypes.animation,
    "backgroundColor",
    "borderRadius",
    "padding",
    "margin",
    
    "color",
    "fontFamily",
    "fontSize",
    attributeTypes.fontWeight,
    attributeTypes.boxShadow,
    "maxHeight",
    "maxWidth",
    "minHeight",
    "minWidth",
    "height",
    "width"

];

export const deafultContainerNonResizableList: string[] =
[
    "backgroundColor",
    "borderRadius",
    "padding",

];

export { defaultDropList, defaultAttributeList  };